import { Type } from 'class-transformer';
import { DimensionSelectorResultDto } from '../../../../shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';
import { APBillReclassRawDto } from './ap-bill-reclass-raw-dto';
import { BudgetedGLAccountSelectorResultDto } from './budgeted-gl-account-selector-result-dto';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';

export class APBillReclassEditorResultDto {
    payee: string;
    payeeCode: string;
    hasVendorNotes: boolean;
    hasBoardNotes: boolean;
    hasNotes: boolean;
    managementCompanyVendorId: number;
    invoiceNumber: string;

    @Type(() => Date)
    invoiceDate: Date;

    @Type(() => Date)
    dueDate: Date;
    invoiceAmount: number;
    vendorAccountNumber: string;

    @Type(() => Date)
    postDate: Date;

    specialHandling: string;
    isEFTAccount: boolean;
    description: string;
    bankAccount: string;

    @Type(() => APBillReclassRawDto)
    apBillReclassInfo: APBillReclassRawDto;

    @Type(() => DimensionSelectorResultDto)
    dimensions: Array<DimensionSelectorResultDto>;

    @Type(() => BudgetedGLAccountSelectorResultDto)
    glAccountsBudgetInfo: Array<BudgetedGLAccountSelectorResultDto>;

    entityUsesSubCategory: boolean;
    requireDimensionMatch: boolean;
    requiredDimension: DimensionOptionResultDto;
}
